(function(w) {
  'use strict';

  // Check dependencies
  if (!Pg.Utils) cWarn('⚠️ Pg.Popup requires Pg.Utils');

  Pg.Popup = {
    // Current popup state (transient, not persisted)
    current: {
      ceF: null,           // current editing frame
      ceB: null,           // current editing box
      ceI: null,           // current editing image
      cuF: null,           // current uploaded frame
      cuB: null,           // current uploaded box
      cuI: null,           // current uploaded image
      ceScale: null,
      ceLeft: null,
      ceTop: null,
      ceBorder: null,
      ceSize: null,
      ceSizeVariant: null,
      ceWidth: null,
      ceHeight: null,
      ceStyle: null,
      ceAcrylic: null,
      ceNW: 0,            // natural width
      ceNH: 0,            // natural height
      cuScale: null,
      cuLeft: null,
      cuTop: null,
      cuSize: null,
      cuSizeVariant: null,
      cuWidth: null,
      cuHeight: null,
      zmSlider: null,      // zoom slider element
      rotation: 0,
      posrotation: 'h',    // position rotation
      SoPchanged: false,   // size or position changed,
      soBchanged: false,
      isOpen: false,
      ceBW: false,
      cuBW: false,
      soBWchanged: false,
    },

    // Direct property access (like the old way)
    get ceF() { return this.current.ceF; },
    get ceB() { return this.current.ceB; },
    get ceI() { return this.current.ceI; },
    get cuF() { return this.current.cuF; },
    get cuB() { return this.current.cuB; },
    get cuI() { return this.current.cuI; },
    get ceScale() { return this.current.ceScale; },
    get ceLeft() { return this.current.ceLeft; },
    get ceTop() { return this.current.ceTop; },
    get ceBorder() { return this.current.ceBorder; },
    get ceSize() { return this.current.ceSize; },
    get ceSizeVariant() { return this.current.ceSizeVariant; },
    get ceWidth() { return this.current.ceWidth; },
    get ceHeight() { return this.current.ceHeight; },
    get ceStyle() { return this.current.ceStyle; },
    get ceAcrylic() { return this.current.ceAcrylic; },
    get ceNW() { return this.current.ceNW; },
    get ceNH() { return this.current.ceNH; },
    get cuScale() { return this.current.cuScale; },
    get cuLeft() { return this.current.cuLeft; },
    get cuTop() { return this.current.cuTop; },
    get cuSize() { return this.current.cuSize; },
    get cuSizeVariant() { return this.current.cuSizeVariant; },
    get cuWidth() { return this.current.cuWidth; },
    get cuHeight() { return this.current.cuHeight; },
    get zmSlider() { return this.current.zmSlider; },
    get rotation() { return this.current.rotation; },
    get posrotation() { return this.current.posrotation; },
    get SoPchanged() { return this.current.SoPchanged; },

    // Setters for commonly modified properties
    set ceScale(value) { this.current.ceScale = value; },
    set ceLeft(value) { this.current.ceLeft = value; },
    set ceTop(value) { this.current.ceTop = value; },
    set cuScale(value) { this.current.cuScale = value; },
    set cuLeft(value) { this.current.cuLeft = value; },
    set cuTop(value) { this.current.cuTop = value; },
    set rotation(value) { this.current.rotation = value; },
    set posrotation(value) { this.current.posrotation = value; },
    set SoPchanged(value) { this.current.SoPchanged = value; },

    // Event listeners for popup events
    listeners: {
      'popup:opened': [],
      'popup:closed': [],
      'popup:updated': []
    },

    // Open popup and populate state
    open() {
      const safeQuery = Pg?.Utils?.safeQuery || (s => {
        try { return document.querySelector(s); } catch(e) { return null; }
      });
      
      // Get editing frame data from DOM
      const ceF = safeQuery('.dp_epu .framefh');
      const edi = safeQuery('.dp_epu .framefh').getAttribute('data-frame-index');
      const cuF = safeQuery('.img-thumbs .frame[data-frame-index="' + edi + '"]');
      
      // Calculate sizes
      const ceWidth = ceF?.dataset.widthInInches;
      const ceHeight = ceF?.dataset.heightInInches;
      const ceSize = ceWidth + 'x' + ceHeight;
      const ceSizeVariant = ceWidth < ceHeight ? ceSize : ceHeight + 'x' + ceWidth;
      
      const cuWidth = cuF?.dataset.widthInInches;
      const cuHeight = cuF?.dataset.heightInInches;
      const cuSize = cuWidth + 'x' + cuHeight;
      const cuSizeVariant = cuWidth < cuHeight ? cuSize : cuHeight + 'x' + cuWidth;
      const style = window.getComputedStyle(cuF.querySelector('.img-box img')).filter;
      // Populate current popup state
      this.current = {
        ceF: ceF,
        ceB: safeQuery('.dp_epu .framefh .img-box'),
        ceI: safeQuery('.dp_epu .framefh .img-box img'),
        cuF: cuF,
        cuB: edi ? safeQuery('.img-thumbs .frame[data-frame-index="' + edi + '"] .img-box') : null,
        cuI: edi ? safeQuery('.img-thumbs .frame[data-frame-index="' + edi + '"] .img-box img') : null,
        ceScale: null,
        ceLeft: null,
        ceTop: null,
        ceBorder: null,
        ceSize: ceSize,
        ceSizeVariant: ceSizeVariant,
        ceWidth: ceWidth,
        ceHeight: ceHeight,
        ceStyle: null,
        ceAcrylic: null,
        ceNW: safeQuery('.img-thumbs .frame[data-frame-index="' + edi + '"] .img-box img')?.naturalWidth,
        ceNH: safeQuery('.img-thumbs .frame[data-frame-index="' + edi + '"] .img-box img')?.naturalHeight,
        cuScale: null,
        cuLeft: null,
        cuTop: null,
        cuSize: cuSize,
        cuSizeVariant: cuSizeVariant,
        cuWidth: cuWidth,
        cuHeight: cuHeight,
        zmSlider: safeQuery('#SCRzoomSlider'),
        rotation: 0,
        posrotation: 'h',
        SoPchanged: false,
        isOpen: true,
        ceBW: style?.includes('grayscale'),
        cuBW: style?.includes('grayscale'),
        soBWchanged: false,
      };
      
      // Set cuScale if getScale function is available
      if (typeof getScale === 'function' && this.current.cuI) {
        this.current.cuScale = getScale(this.current.cuI);
      }
      
      this.triggerEvent('popup:opened', { edi });
      cLog('🔄 Popup opened', { frameIndex: edi });
    },

    // Close popup and reset state
    close() {
      this.current = {
        ceF: null, ceB: null, ceI: null, cuF: null, cuB: null, cuI: null,
        ceScale: null, ceLeft: null, ceTop: null, ceBorder: null,
        ceSize: null, ceSizeVariant: null, ceWidth: null, ceHeight: null,
        ceStyle: null, ceAcrylic: null, ceNW: 0, ceNH: 0,
        cuScale: null, cuLeft: null, cuTop: null, cuSize: null, 
        cuSizeVariant: null, cuWidth: null, cuHeight: null,
        zmSlider: null, rotation: 0, posrotation: 'h', 
        SoPchanged: false, isOpen: false
      };
      
      this.triggerEvent('popup:closed', {});
      cLog('🔄 Popup closed');
    },

    // Update popup state
    update(updates = {}) {
      if (!this.current.isOpen) return false;
      
      Object.assign(this.current, updates);
      this.triggerEvent('popup:updated', { updates });
      return true;
    },

    // Get current popup state
    get(key = null) {
      return key ? this.current[key] : { ...this.current };
    },

    // Check if popup is open
    isOpen() {
      return this.current.isOpen;
    },

    // Event system
    on(event, callback) {
      if (!this.listeners[event]) this.listeners[event] = [];
      this.listeners[event].push(callback);
      
      return () => {
        const index = this.listeners[event].indexOf(callback);
        if (index > -1) this.listeners[event].splice(index, 1);
      };
    },

    triggerEvent(type, data = {}) {
      const event = { type, data, timestamp: Date.now(), popup: this.get() };
      
      this.listeners[type]?.forEach(callback => {
        try {
          callback(event);
        } catch (error) {
          console.error(`❌ Popup event error (${type}):`, error);
        }
      });
    },

    // Debug helper
    debugState() {
      console.group('🔍 Popup State Debug');
      console.log('📋 Current State:', this.current);
      console.log('🎯 Is Open:', this.isOpen());
      console.groupEnd();
    }
  };

  // Mark module as loaded
  if (Pg.moduleStatus) {
    Pg.moduleStatus.popup = true;
    Pg.checkModules?.();
  }

  cLog('✅ Pg.Popup: Transient popup state manager loaded');

})(window); 